export const ProductTypes = {
    AppointmentsService: 'APPOINTMENTS_SERVICE'
}